<template>
  <div>
    <v-app class="p-4">
      <!--      start edit mode -->
      <template>
        <span id="snackbar">متن مورد نظر با موفقیت کپی شد!</span>
        <v-row justify="center">
          <v-dialog
              v-model="editModal"
              max-width="700px"
              transition="dialog-bottom-transition"
          >
            <v-card v-if="editModal">
              <v-toolbar
                  dark
                  color="primary"
              >
                <v-toolbar-title>ویرایش شماره</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="editModal = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <div class="p-4 mx-auto mt-3">
                <div class="row mx-auto my-3">
                  <p>
                    کارتن :
                    <span style="user-select: all" class="text-info">
                                            {{ this.justShow.carton != null ? justShow.carton : 'وجود ندارد!' }}
                                        </span>
                  </p>

                  <p class="mx-auto">
                    پک :
                    <span style="user-select: all" class="text-info">
                                            {{ justShow.pack != null ? justShow.pack : 'وجود ندارد!' }}
                                        </span>
                  </p>

                  <p class="mx-auto">
                    پوکه :
                    <span style="user-select: all" class="text-info">
                                        {{ justShow.pocket != null ? justShow.pocket : 'وجود ندارد!' }}
                                        </span>
                  </p>
                </div>
                <div class="row mx-auto my-3">
                  <p>
                    شماره تماس :
                    <span @click="copyData(oldData.phone)" style="user-select: all"
                          class="text-primary">
                                        {{ oldData.phone }}
                                        </span>
                  </p>

                  <p class="mx-auto">
                    تاریخ ایجاد توکن :
                    <span style="user-select: all" class="text-primary">
                                            {{ oldData.iat }}
                                        </span>
                  </p>

                  <p class="mx-auto">
                    تاریخ انقضا توکن :
                    <span style="user-select: all" class="text-primary">
                                            {{ oldData.exp }}
                                        </span>
                  </p>
                </div>

                <p>
                  توکن دیوار :
                  <span @click="copyData(oldData.divar_token)" style="user-select: all"
                        class="text-info">
                                        {{ oldData.divar_token }}
                                    </span>
                </p>
              </div>
              <div class="row px-4 pt-4 pb-0 mt-3">
                <div class="col-md-6">
                  <v-autocomplete outlined
                                  label="وضعیت"
                                  @input="getVal($event,'can_divert')"
                                  clear-icon="mdi-close-circle-outline"
                                  prepend-inner-icon="fa fa-pencil-alt"
                                  clearable
                                  :items="canDivertList"
                                  item-text="name"
                                  v-model="oldData.can_divert"
                                  item-value="value"
                                  dense>

                  </v-autocomplete>
                </div>
                <div class="col-md-6">
                  <v-autocomplete outlined
                                  label="وضعیت"
                                  clear-icon="mdi-close-circle-outline"
                                  prepend-inner-icon="fa fa-pencil-alt"
                                  clearable
                                  @input="getVal($event,'is_rond')"
                                  dense
                                  :items="roandLinesList"
                                  v-model="oldData.is_rond"
                                  item-text="name"
                                  item-value="value"
                  >
                  </v-autocomplete>
                </div>

                <div class="row mx-auto">
                  <div class="col-md-6">
                    <v-autocomplete outlined
                                    label="وضعیت"
                                    clear-icon="mdi-close-circle-outline"
                                    prepend-inner-icon="fa fa-pencil-alt"
                                    clearable
                                    @input="getVal($event,'is_return')"
                                    dense
                                    :items="returnedLinesList"
                                    v-model="oldData.is_return"
                                    item-text="name"
                                    item-value="value"
                    >
                    </v-autocomplete>
                  </div>
                  <div class="col-md-6">
                    <users-component :old-data="oldData.user ? oldData.user.full_name: '' "
                                     v-if="editModal"></users-component>
                  </div>
                </div>
                <v-btn @click="updateData(oldData.id)" class="float-left mx-5 mb-5 btn-update">
                  <span class="fa fa-recycle ml-1"></span>
                  به روز رسانی شماره
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->

      <!--      start edit mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="filterModal"
              max-width="700px"
              transition="dialog-bottom-transition"
          >
            <v-card v-if="filterModal">
              <v-toolbar
                  dark
                  color="primary"
              >
                <v-toolbar-title>فیلتر شماره</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="filterModal = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <div class="row px-4 pt-4 pb-0 mt-3">
                <div class="col-md-6">
                  <v-autocomplete outlined
                                  label="وضعیت دایورت"
                                  @input="getValue($event,'can_divert')"
                                  clear-icon="mdi-close-circle-outline"
                                  prepend-inner-icon="fa fa-pencil-alt"
                                  clearable
                                  :items="canDivertList"
                                  item-text="name"
                                  item-value="value"
                                  dense>

                  </v-autocomplete>
                </div>
                <div class="col-md-6">
                  <v-autocomplete outlined
                                  label="وضعیت خطوط رند"
                                  clear-icon="mdi-close-circle-outline"
                                  prepend-inner-icon="fa fa-pencil-alt"
                                  clearable
                                  @input="getValue($event,'is_rond')"
                                  dense
                                  :items="roandLinesList"
                                  item-text="name"
                                  item-value="value"
                  >
                  </v-autocomplete>
                </div>

                <div class="row mx-auto">
                  <div class="col-md-6">
                    <v-autocomplete outlined
                                    label="وضعیت خطوط بازگشتی"
                                    clear-icon="mdi-close-circle-outline"
                                    prepend-inner-icon="fa fa-pencil-alt"
                                    clearable
                                    @input="getValue($event,'is_return')"
                                    dense
                                    :items="returnedLinesList"
                                    item-text="name"
                                    item-value="value"
                    >
                    </v-autocomplete>
                  </div>
                  <div class="col-md-6">
                    <users-component v-if="filterModal"></users-component>
                  </div>
                </div>

                <v-btn @click="filter" class="float-left mx-5 mb-5 btn-update">
                  <span class="fa fa-filter ml-1"></span>
                  فیلتر
                </v-btn>

                <v-btn @click="showExpireOnly" class="btn-update-danger">
                  <span class="fa fa-filter ml-1"></span>
                  فیلتر شماره ها منقضی شده
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->

      <!--      start edit mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="TokenUpdate"
              max-width="700px"
              transition="dialog-bottom-transition"
          >
            <v-card v-if="TokenUpdate">
              <v-toolbar
                  dark
                  color="primary"
              >
                <v-toolbar-title>فیلتر شماره</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="TokenUpdate = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <div class="col-md-12  px-4 pt-4 pb-0 mt-3">
                <div class="col-md-6 text-center mx-auto">
                  <v-text-field outlined
                                label="شماره تلفن"
                                v-model="loginPhone"
                                prepend-inner-icon="fa fa-pencil-alt"
                                disabled
                                dense>

                  </v-text-field>
                </div>
                <div class="col-md-6 text-center mx-auto">
                  <v-otp-input
                      length="6"
                      v-model="logCode"
                      @finish="UpdateToken"
                      type="number"
                      style="direction: ltr"
                      ref="codes"
                  ></v-otp-input>
                </div>
              </div>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->  <!--      start edit mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="addNewNum"
              max-width="700px"
              transition="dialog-bottom-transition"
          >
            <v-card v-if="addNewNum">
              <v-toolbar
                  dark
                  color="primary"
              >
                <v-toolbar-title>افزودن شماره خود</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="addNewNum = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <add-new-numbers v-if="addNewNum" :list="true"></add-new-numbers>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->

      <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
        <div class="mt-5 pt-5">
          <div class="row mt-5 mx-auto text-center">
            <div :class="!isMobile?'col-md-9 text-right' : 'col-6 text-right'">
              <v-btn fab outlined x-small color="indigo" v-b-tooltip.hover="'فیلتر اطلاعات'"
                     @click="filterModal = true"><span style="font-size: 1rem"
                                                       class="fa fa-filter"></span></v-btn>
            </div>
            <div :class="!isMobile?'col-md' : 'col-6' ">
              <v-file-input
                  class="d-none"
                  accept="text/csv, text/txt"
                  v-model="csv"
                  truncate-length="15"
                  @change="UploadFile"
                  ref="uploadCsv"
              ></v-file-input>
              <div class="d-flex float-left">
                <v-btn :class="!isMobile? ' float-left btn-upload mt-0 ' : 'float-left btn-upload mr-auto text-left'"
                       small @click="openCsv">
                  <span class="fa fa-upload mr-3"></span>
                  بارگذاری فایل csv
                </v-btn>
                <v-btn
                    :class="!isMobile? ' float-left btn-add-with-text mt-0 ' : 'float-left btn-add-with-text mr-auto text-left'"
                    small @click="addNewNum=true">
                  <span class="fa fa-plus ml-1"></span>
                  افزودن شماره جدید
                </v-btn>
              </div>
            </div>
          </div>

          <v-card :loading="loading" class="p-3 pt-0 mt-4">
            <terminal-table class="col-12" :currentPage="data.current_page"
                            :perPage="data.per_page" v-if="isMobile" :getData="getDataForTable"
                            :pageCount="data.last_page"
                            :options="tableProps" :datas="data" :headers="columns"></terminal-table>
            <data-table
                v-else
                :data="data"
                :columns="columns"
                :debounce-delay="3000"
                :translate="translate"
                :per-page="[10, 25, 50, 100, 500]"
                :orderBy="tableProps.column"
                :orderDir="tableProps.dir"
                :pagination="paginate"
                @on-table-props-changed="reloadTable"
                class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
            >
              <template slot="filters" slot-scope="{ tableFilters, perPage }">
                <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                               v-model="searchBox">

                  <template slot="others">
                    <div class="row mb-2">
                      <v-checkbox dense
                                  label="کپچا"
                                  @change="reloadTable"
                                  v-model="searchBox.captcha"/>

                      <date-picker type="date"
                                   :timezone="false"
                                   auto-submit
                                   format="YYYY-MM-DD"
                                   display-format="jYYYY-jMM-jDD"
                                   label="از ‌تاریخ"
                                   @change="reloadTable"
                                   v-model="searchBox.expire_at"/>

                    </div>
                  </template>
                </filters-table>
              </template>
            </data-table>
          </v-card>
        </div>

      </div>
    </v-app>
  </div>
</template>
<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {Axios2, Bus, dataTableProps} from "@/main";
import button from "@/view/pages/button";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import {debounce} from "../../../custom";
import UsersComponent from "@/view/pages/numbers/UsersComponent";
import FiltersTable from "@/components/Table/filtersTable";
import AddNewNumbers from "@/view/pages/numbers/addnew";

export default {
  name: "userNumMonitor",
  components: {AddNewNumbers, FiltersTable, UsersComponent, ButtonTempl, TitleRibbon},
  props: {
    uniquePack: {
      default: '',
      require: true
    }
  },
  data() {
    return {
      oldData: [],
      editModal: false,
      loading: false,
      filterModal: false,
      addNewNum: false,
      TokenUpdate: false,
      csv: '',
      loginPhone: '',
      logCode: '',
      filterData: {},
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      roandLinesList: [
        {
          id: 1,
          name: 'رند هست',
          value: 'yes'
        },
        {
          id: 2,
          name: 'رند نیست',
          value: 'no'
        }
      ],
      filters: [
        {
          id: 1,
          name: 'خطوط رند',
          value: 'yes',
          englishValue: 'rond',
          status: false
        },
        {
          id: 2,
          name: 'خطوط غیر رند',
          value: 'no',
          englishValue: 'rond',
          status: false
        },
        {
          id: 3,
          name: 'خطوط بازگشتی',
          value: 'yes',
          englishValue: 'return',
          status: false
        },
        {
          id: 4,
          name: 'خطوط آزاد',
          value: 'no',
          englishValue: 'return',
          status: false
        },
        {
          id: 5,
          name: 'خطوط قابل دایورت',
          value: 'yes',
          englishValue: 'divert',
          status: false
        },
        {
          id: 6,
          name: 'خطوط غیر قابل دایورت',
          value: 'no',
          englishValue: 'divert',
          status: false
        },
      ],
      newData: {},
      returnedLinesList: [
        {
          id: 1,
          name: ' بازگشتی',
          value: 'yes'
        },
        {
          id: 2,
          name: ' آزاد',
          value: 'no'
        }
      ],
      canDivertList: [
        {
          id: 1,
          name: 'قابل دایورت',
          value: 'yes',
        },
        {
          id: 2,
          name: 'غیرقابل دایورت',
          value: 'no',
        }
      ],
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'شماره',
          name: 'phone',
          primary: true,
          orderable: true,
          searchable: true,
        },
        {
          label: 'موجودی',
          name: 'balance',
          transform: (val) => {
            return ` <span class="badge badge-primary p-2 px-4 mt-2">${val.data.balance != null ? val.data.balance + '﷼' : 0}</span>`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مالک',
          name: 'owner_full_name',
          primary: true,
          transform: (val) => {
            return val.data.owner_full_name ? val.data.owner_full_name : 'ندارد'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'اطلاعات شماره',
          name: 'pack',
          transform: (val) => {
            const pack = val.data.pack
            const pocke = val.data.pocket
            const carton = val.data.carton
            return `<span class="badge badge-warning">پک : ${pack}</span><span class="badge badge-warning">پوکه : ${pocke}</span><span class="badge mt-1 badge-warning">کارتن : ${carton}</span>`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: ' انقضای توکن',
          name: 'token_time',
          transform(val) {
            return val.data.exp
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'وضعیت',
          name: 'owner_username',
          transform: (val) => {
            const success = val.data.owner_full_name != null && val.data.owner_username != null ? '' : 'badge-success';
            return `<span class="badge ${success} rounded-circle mt-2 p-2">${val.data.owner_full_name != "" && val.data.owner_username != null ? 'اختصاص داده شده به ' + val.data.owner_full_name : ' '}</span>`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            permission_prefix: 'notification_',
            buttons: [
              {
                name: 'goToDivar',
                label: 'برو به دیوار',
                icon: 'paper-plane',
                class: 'btn-outline-primary',
                action: this.actions,
                status: 'all'
              },
              {
                name: 'delete',
                label: 'حذف شماره',
                icon: 'trash-alt',
                class: 'btn-outline-danger',
                action: this.actions,
                status: 'admin_number_destroy'
              },
              {
                name: 'edit',
                label: 'ویرایش آگهی',
                icon: 'pencil-alt',
                class: 'btn-outline-warning',
                action: this.actions,
                status: 'admin_number_update'
              },
              {
                name: 'updateToken',
                label: 'به روزرسانی توکن',
                icon: 'retweet',
                class: 'btn-outline-primary',
                action: this.actions,
                status: 'admin_number_update'
              },
              {
                name: 'updateCaptcha',
                label: 'تایید کپچا',
                icon: 'check',
                class: 'btn-outline-success',
                action: this.actions,
                status: 'admin_number_update'
              },
            ]
          }
        }
      ],
      justShow: [],
      data: {},
      url: `${url}/admin/numbers`,
      searchBox: {
        search: '',
        length: 10,
        expire_at: undefined,
        captcha: undefined
      },
    }
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;

      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: Object.assign({}, query, this.filterData, {
          search: this.tableProps.search,
          length: this.searchBox.length,
          expire_at: this.searchBox.expire_at || undefined,
          dir: this.searchBox.expire_at ? 'asc' : undefined,
          column: this.searchBox.expire_at ? 'token_time' : undefined,
          has_captcha: this.searchBox.captcha ? 1 : undefined,
        }),
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.data = data.data;
          vm.loading = false;
        }
      })
    },

    refreshIt(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: query,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.data = data.data;
          vm.loading = false;
        }
      })
    },

    updateData(value) {
      $.ajax({
        url: `${url}/admin/numbers/${value}`,
        type: 'PUT',
        fn: this.updateData,
        params: [value],
        headers: {
          ACCEPT: 'application/json',
          AUTHORIZATION: Token,
          "Content-Type": 'application/json'
        },
        data: JSON.stringify(this.newData),
        msg: true,
        success: (res) => {
          this.oldData = [];
          this.editModal = false;
          this.reloadTable();
          this.newData = {};
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 1000);
    },
    UpdateToken() {
      $.ajax({
        url: `${url}/admin/numbers/set/token/${this.loginPhone}`,
        type: 'PUT',
        fn: this.UpdateToken,
        headers: {
          ACCEPT: 'application/json',
          AUTHORIZATION: Token,
          "Content-Type": 'application/json'
        },
        data: JSON.stringify({code: this.logCode}),
        msg: true,
        success: (res) => {
          this.TokenUpdate = false;
          this.logCode = '';
        }
      })
    },
    actions(data, type) {
      const vm = this

      this.oldData = [];

      if (type === 'edit') {
        vm.editModal = true;
        vm.justShow = data
        $.ajax({
          url: `${url}/admin/numbers/${data.id}`,
          type: 'GET',
          fn: this.actions,
          params: [data, type],
          headers: {
            'Authorization': Token,
            ACCEPT: 'application/json',
          },
          success: (res) => {
            this.oldData = res.data
          }
        })

      } else if (type === 'delete') {

        this.$modal.yesNo('تایید حذف', 'آیا از حذف این دسته اطمینان دارید؟', "neg", '').then((value => {
          if (value === true) {
            $.ajax({
              url: `${url}/admin/numbers/${data.id}`,
              type: 'DELETE',
              fn: this.actions,
              params: [data, type],
              headers: {
                'Authorization': Token,
                ACCEPT: 'application/json',
              },
              msg: true,
            })
          }
        }))

      } else if (type === 'goToDivar') {
        $.ajax({
          url: `${url}/admin/fresh`,
          type: 'POST',
          data: JSON.stringify({'token': data.divar_token}),
          headers: {
            "ACCEPT": "application/json",
            "Authorization": Token,
            "Content-Type": "application/json"
          },
          msg: false,
          success() {
            window.open(`https://divar.ir/my-divar/my-posts?token=${data.divar_token}`, '_blank');
          }
        })
      } else if (type === 'updateToken') {

        this.TokenUpdate = true;
        this.loginPhone = data.phone;

        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.codes.focus();
          })
        });

        $.ajax({
          url: `${url}/phone/authenticate`,
          type: 'POST',
          data: JSON.stringify({'phone': data.phone}),
          headers: {
            "ACCEPT": "application/json",
            "Authorization": Token,
            "Content-Type": "application/json"
          },
          msg: true,
        });
      } else if (type === 'updateCaptcha') {
        $.ajax({
          url: `${url}/captcha`,
          type: 'PUT',
          data: JSON.stringify({
            phone: data.phone,
            status: false
          }),
          headers: {
            "ACCEPT": "application/json",
            "Authorization": Token,
            "Content-Type": "application/json"
          },
          msg: true,
        })
      }
    },
    getVal($event, name) {
      this.newData[name] = $event
    },
    copyData(val) {
      // navigator clipboard api needs a secure context (https)
      let sb = document.getElementById("snackbar");
      sb.className = "show";
      setTimeout(() => {
        sb.className = sb.className.replace("show", "");
      }, 3000);

      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard api method'
        return navigator.clipboard.writeText(val);
      } else {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = val;
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
          // here the magic happens
          document.execCommand('copy') ? res() : rej();
          textArea.remove();
        });
      }
    },
    getValue($event, name) {
      if ($event === null) {
        this.filterData[name] = undefined
      } else
        this.filterData[name] = $event;
      if (name === 'user' && $event == null) {
        this.filterData[name] = undefined;
      }
    },
    filter() {
      this.reloadTable(this.tableProps);
      this.filterModal = false;
    },
    showExpireOnly() {
      this.filterData = {};
      this.filterData['expired'] = true;

      this.reloadTable(this.tableProps);

      this.filterModal = false;
    },
    openCsv() {
      this.$refs.uploadCsv.$refs.input.click();
    },
    UploadFile() {

      let formData = new FormData();
      formData.append('csv', this.csv);

      Axios2.post('/admin/csv', formData).then((x) => {
        this.$modal.success('موفق!', x.data.message);
        Bus.$emit('getFile', x.data.data);

      }).catch((error) => {
        this.$modal.error('خطا!', error.response.data.errors.csv[0])
        this.progressPercent = '';
      });
    }
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url)

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    })

    Bus.$on('manufacturersPicker', (value) => {
      if (this.filterModal) {
        this.getValue(value, 'user');
      } else
        this.newData['user_id'] = value;

    })
  },
}
</script>

<style>
#snackbar {
  visibility: hidden;
  color: #fff;
  background-color: #333;
  min-width: 250px;
  margin-left: -125px;
  border-radius: 2px;
  padding: 16px;
  text-align: center;
  left: 50%;
  bottom: 30px;
  z-index: 1;
  position: fixed;
}

/* This will be activated when the snackbar's class is 'show' which will be added through JS */
#snackbar.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations for fading in and out */
@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 50px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

.btn-update-danger {
  margin: 10px;
  border: 1px solid #96005AFF !important;
  padding: 15px 60px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.7s !important;
  font-weight: bold !important;
  background-size: 200% auto;
  color: #960034FF !important;
  border-radius: 5px !important;
  display: block;
}

.btn-update-danger:hover {
  background-image: linear-gradient(to right, #960050FF 0%, rgb(255, 0, 128) 51%, #960050FF 100%);
  background-position: right center;
  color: #fff !important;
  text-decoration: none !important;
  border: none !important;
  transition: 0.7s !important;
  font-weight: bold !important;
  box-shadow: 0 0 20px #eee;
}
</style>
